<template>
  <v-container
    fluid
    grid-list-xl
    fill-height>
    <v-layout
      justify-center
      align-center>
      <v-flex
        xs12
        sm8
        md4>
        <material-card
          color="orange"
          title="Quality CMS - Forgot Password"
          text="Please insert your Email"
        >
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md12>
                  <v-text-field
                    v-model="forgotForm.username"
                    :rules="validators.username"
                    prepend-icon="mdi-account"
                    name="username"
                    label="Email"
                    type="text"
                  />
                </v-flex>



                 <v-flex
                  xs6
                  text-left>
                  <br>
                  <a @click="loginPage">Login page</a>
                </v-flex>


                <v-flex
                  xs6
                  text-right>
                  <v-btn
                    color="orange"
                    :disabled='loading'
                    :loading='loading'
                    class="mx-0 font-weight-light"
                    @click="forgot"
                  >Send</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import validators from '@/utils/validators'
import { forgotPass } from '@/api/user'

export default {
  data: () => ({
    loading: false,
    forgotForm: {
      username: ''
    },
    validators
  }),

  methods: {
    async forgot () {
      this.loading = true
      try {
        await forgotPass({ email: this.forgotForm.username })
        this.$root.$emit('openSnackbar', { message: 'Password reset requested. Please check your e-mail. ', color: 'success'})
          this.$router.push({ path: '/login' })
      } catch (e) {
        this.$root.$emit('openSnackbar', { message: 'An error occurred during password reset request. ', color: 'red'})
      }
      this.loading = false
    },
    loginPage () {
      this.$router.push({ path: '/login' })
    },
  }
}
</script>
